/*
 * /transcripts (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import {
	Container,
	Divider,
	Page,
	PageHeader,
	Skeleton,
} from "@psychology/react-ui"
import { ArrowLeft } from "lucide-react"
import { TranscriptList } from "../../features/transcript/components/transcript-list"
import { trpc } from "../../trpc"
import { authPageLoader } from "../../utils/auth.utils"

export const Route = createFileRoute("/transcripts/")({
	component: TranscriptsPage,
	loader: authPageLoader,
})

function TranscriptsPage() {
	const { user } = Route.useLoaderData()

	const { data: transcripts, isLoading } =
		trpc.conversationTranscript.getAllByFilter.useQuery({
			sort: { column: "createdAt", direction: "desc" },
			where: { userId: user.id },
		})

	return (
		<Page centerVertical={false}>
			<Container width={"xl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={"Transcript Review"}
					left={{
						href: "/dashboard",
						label: "Dashboard",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				{!isLoading && transcripts && (
					<p className={"text-muted-foreground text-sm"}>
						{`${transcripts.length} ${transcripts.length === 1 ? "transcript" : "transcripts"}`}
					</p>
				)}
				{isLoading ? (
					<div className={"space-y-4"}>
						{[1, 2, 3].map((i) => (
							<Skeleton key={i} className={"h-[80px] w-full rounded-lg"} />
						))}
					</div>
				) : (
					<TranscriptList transcripts={transcripts || []} />
				)}
			</Container>
		</Page>
	)
}
